import React, { useState } from 'react';

// Non-production tooling: replays the Stripe webhook that books this donation by
// POSTing the stripe_client_secret to the test_support endpoint. Rendered only in
// non-production environments (gated by the nonProduction prop), so it never appears
// in production.
const csrfToken = () => {
  if (typeof document === 'undefined') return null;
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : null;
};

const SimulateWebhookButton = ({ clientSecret }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [message, setMessage] = useState('');

  const simulate = async () => {
    if (!clientSecret || loading) return;
    setLoading(true);
    setStatus(null);
    setMessage('');
    const token = csrfToken();

    try {
      const response = await fetch('/test_support/donations/simulate_webhook', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(token ? { 'X-CSRF-Token': token } : {}),
        },
        body: JSON.stringify({ client_secret: clientSecret }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'Webhook simulated.');
      } else {
        setStatus('error');
        setMessage(data.error || 'Simulation failed.');
      }
    } catch (e) {
      setStatus('error');
      setMessage('Could not reach the server.');
    }

    setLoading(false);
  };

  return (
    <div className="gc-dev-panel">
      <div className="gc-dev-panel-header">
        <span className="gc-dev-panel-badge">Test mode</span>
        <span className="gc-dev-panel-note">Not available in production</span>
      </div>
      <p className="gc-dev-panel-desc">
        Stripe webhooks don’t run outside production. Simulate the payment webhook to book this donation.
      </p>
      <button type="button" className="gc-dev-simulate-btn" onClick={simulate} disabled={loading}>
        {loading ? 'Simulating…' : '⚡ Simulate payment webhook'}
      </button>
      {message && (
        <p className={`gc-dev-simulate-msg gc-dev-simulate-msg--${status}`}>{message}</p>
      )}
    </div>
  );
};

export default SimulateWebhookButton;
